function _array_like_to_array(arr, len) {
    if (len == null || len > arr.length) len = arr.length;
    for(var i = 0, arr2 = new Array(len); i < len; i++)arr2[i] = arr[i];
    return arr2;
}
function _array_with_holes(arr) {
    if (Array.isArray(arr)) return arr;
}
function asyncGeneratorStep(gen, resolve, reject, _next, _throw, key, arg) {
    try {
        var info = gen[key](arg);
        var value = info.value;
    } catch (error) {
        reject(error);
        return;
    }
    if (info.done) {
        resolve(value);
    } else {
        Promise.resolve(value).then(_next, _throw);
    }
}
function _async_to_generator(fn) {
    return function() {
        var self = this, args = arguments;
        return new Promise(function(resolve, reject) {
            var gen = fn.apply(self, args);
            function _next(value) {
                asyncGeneratorStep(gen, resolve, reject, _next, _throw, "next", value);
            }
            function _throw(err) {
                asyncGeneratorStep(gen, resolve, reject, _next, _throw, "throw", err);
            }
            _next(undefined);
        });
    };
}
function _iterable_to_array_limit(arr, i) {
    var _i = arr == null ? null : typeof Symbol !== "undefined" && arr[Symbol.iterator] || arr["@@iterator"];
    if (_i == null) return;
    var _arr = [];
    var _n = true;
    var _d = false;
    var _s, _e;
    try {
        for(_i = _i.call(arr); !(_n = (_s = _i.next()).done); _n = true){
            _arr.push(_s.value);
            if (i && _arr.length === i) break;
        }
    } catch (err) {
        _d = true;
        _e = err;
    } finally{
        try {
            if (!_n && _i["return"] != null) _i["return"]();
        } finally{
            if (_d) throw _e;
        }
    }
    return _arr;
}
function _non_iterable_rest() {
    throw new TypeError("Invalid attempt to destructure non-iterable instance.\\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
}
function _sliced_to_array(arr, i) {
    return _array_with_holes(arr) || _iterable_to_array_limit(arr, i) || _unsupported_iterable_to_array(arr, i) || _non_iterable_rest();
}
function _unsupported_iterable_to_array(o, minLen) {
    if (!o) return;
    if (typeof o === "string") return _array_like_to_array(o, minLen);
    var n = Object.prototype.toString.call(o).slice(8, -1);
    if (n === "Object" && o.constructor) n = o.constructor.name;
    if (n === "Map" || n === "Set") return Array.from(n);
    if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _array_like_to_array(o, minLen);
}
function _ts_generator(thisArg, body) {
    var f, y, t, g, _ = {
        label: 0,
        sent: function() {
            if (t[0] & 1) throw t[1];
            return t[1];
        },
        trys: [],
        ops: []
    };
    return g = {
        next: verb(0),
        "throw": verb(1),
        "return": verb(2)
    }, typeof Symbol === "function" && (g[Symbol.iterator] = function() {
        return this;
    }), g;
    function verb(n) {
        return function(v) {
            return step([
                n,
                v
            ]);
        };
    }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while(_)try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [
                op[0] & 2,
                t.value
            ];
            switch(op[0]){
                case 0:
                case 1:
                    t = op;
                    break;
                case 4:
                    _.label++;
                    return {
                        value: op[1],
                        done: false
                    };
                case 5:
                    _.label++;
                    y = op[1];
                    op = [
                        0
                    ];
                    continue;
                case 7:
                    op = _.ops.pop();
                    _.trys.pop();
                    continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) {
                        _ = 0;
                        continue;
                    }
                    if (op[0] === 3 && (!t || op[1] > t[0] && op[1] < t[3])) {
                        _.label = op[1];
                        break;
                    }
                    if (op[0] === 6 && _.label < t[1]) {
                        _.label = t[1];
                        t = op;
                        break;
                    }
                    if (t && _.label < t[2]) {
                        _.label = t[2];
                        _.ops.push(op);
                        break;
                    }
                    if (t[2]) _.ops.pop();
                    _.trys.pop();
                    continue;
            }
            op = body.call(thisArg, _);
        } catch (e) {
            op = [
                6,
                e
            ];
            y = 0;
        } finally{
            f = t = 0;
        }
        if (op[0] & 5) throw op[1];
        return {
            value: op[0] ? op[1] : void 0,
            done: true
        };
    }
}
import _ from 'lodash/fp';
import { PRODUCT_DATA } from '../components/mapView/constants';
import { computeArea, computeIntersection, computeMinEnvelope, computeUnion, computeVisualCenter, computeWidthHeight, hasOverlap } from '../components/mapView/geometry';
// Promise.all but for objects
var promiseAllObj = /*#__PURE__*/ function() {
    var _ref = _async_to_generator(function(obj) {
        var _1, _tmp;
        return _ts_generator(this, function(_state) {
            switch(_state.label){
                case 0:
                    _1 = _.zipObj;
                    _tmp = [
                        _.keys(obj)
                    ];
                    return [
                        4,
                        Promise.all(_.values(obj))
                    ];
                case 1:
                    return [
                        2,
                        _1.apply(_, _tmp.concat([
                            _state.sent()
                        ]))
                    ];
            }
        });
    });
    return function promiseAllObj(obj) {
        return _ref.apply(this, arguments);
    };
}();
var COVERAGE_MIN_DIMENSION_IN_M = 10;
export var getUnseenHashes = function(hashesToAdd, hashes) {
    return _.difference(hashesToAdd, hashes);
};
var reorderCoverage = function(coverage) {
    return _.sortBy(function(product) {
        return PRODUCT_DATA.entities[product.category_name].order;
    })(coverage);
};
// EDGE CASE: it is possible that coverage queries could yield different product IDs for the same product type
// This is rare, since products are generally defined for very large areas e.g. VIC, NSW, QLD
// so this should only happen when the coverage is queried across borders.
// In these cases, the products will not load properly.
// TODO: ^
export var mergeCoverage = function(coverages) {
    var merged = _.reduce(function(merged, products) {
        return _.flow(_.map(function(product) {
            var existingProduct = merged === null || merged === void 0 ? void 0 : merged[product.category_name];
            return _.set(product.category_name, _.flow(_.map(function(param) {
                var _param = _sliced_to_array(param, 2), k = _param[0], v = _param[1];
                if (existingProduct) {
                    if (k === 'area_in_sqm') {
                        return _.set(k, v + existingProduct[k]);
                    }
                    if (k === 'geometry') {
                        return _.set(k, computeUnion(v, existingProduct[k]));
                    }
                    if (k === 'layers') {
                        return _.set(k, _.reduce(function(prevLayers, newLayer) {
                            var existingLayer = prevLayers === null || prevLayers === void 0 ? void 0 : prevLayers[newLayer.layer_id];
                            if (existingLayer) {
                                return _.set(newLayer.layer_id, _.flow(_.map(function(param) {
                                    var _param = _sliced_to_array(param, 2), k = _param[0], v = _param[1];
                                    if (k === 'area_in_sqm') {
                                        return _.set(k, v + existingLayer[k]);
                                    }
                                    if (k === 'geometry') {
                                        var union = computeUnion(v, existingLayer[k]);
                                        return _.set(k, union);
                                    }
                                    if (k === 'marker_locations') {
                                        return _.set(k, _.concat(v, existingLayer[k]));
                                    }
                                    if (k === 'acquired_at') {
                                        return _.set(k, v);
                                    }
                                    console.assert(v === existingLayer[k], "layer ".concat(newLayer.layer_id, " has different ").concat(k, " value to existing layer ").concat(existingLayer.layer_id, ": ").concat(v, " vs ").concat(existingLayer[k]));
                                    return _.set(k, v);
                                })(_.toPairs(newLayer)))(existingLayer))(prevLayers);
                            }
                            return _.set(newLayer.layer_id, newLayer)(prevLayers);
                        })(existingProduct.layers)(v));
                    }
                }
                return _.set(k, v);
            })(_.toPairs(product)))(product));
        })(products))(merged);
    })({})(coverages);
    return reorderCoverage(merged);
};
/**
 * @param geometry - GeoJSON geometry of a polygon or multi-polygon
 * @returns true iff the geometry has an envelope with width and height greater than the minimum.
 */ var coverageFilter = function(geometry) {
    var envelope = computeMinEnvelope(geometry);
    var _computeWidthHeight = _sliced_to_array(computeWidthHeight(envelope), 2), width = _computeWidthHeight[0], height = _computeWidthHeight[1];
    return width >= COVERAGE_MIN_DIMENSION_IN_M && height >= COVERAGE_MIN_DIMENSION_IN_M;
};
export var filterProductCoverageLayersByIntersection = function(productCoverage, geometry) {
    // TODO: issue with coverage, streetscape layers returns 'Polygon' as geometry type, when actually 'MultiPolygon'
    // this is not a bug in practice, since computeIntersection knows how to handle both
    var intersectingLayers = _.reduce(function(layers, layer) {
        var intersection = computeIntersection(layer.geometry, geometry);
        var markerLocations = [];
        if (intersection) {
            if (intersection.type === 'Polygon') {
                if (coverageFilter(intersection)) {
                    var centroid = computeVisualCenter(intersection);
                    markerLocations.push(centroid.coordinates);
                }
            } else {
                console.assert(intersection.type === 'MultiPolygon');
                _.forEach(function(coords) {
                    var geom = {
                        type: 'Polygon',
                        coordinates: coords
                    };
                    if (coverageFilter(geom)) {
                        var centroid = computeVisualCenter(geom);
                        markerLocations.push(centroid.coordinates);
                    }
                }, intersection.coordinates);
            }
            return _.set(layer.layer_id, _.flow(_.set('geometry', intersection), _.set('marker_locations', markerLocations), _.set('area_in_sqm', computeArea(intersection)) // TODO: fixme
            )(layer))(layers);
        }
        return layers;
    })({})(productCoverage.layers);
    // TODO: set the area_in_sqm of the product to the sum of the areas of the intersecting layers
    return _.set('layers', intersectingLayers)(productCoverage);
};
export var filterCoverageLayersByIntersection = /*#__PURE__*/ function() {
    var _ref = _async_to_generator(function(coverage, geometry) {
        var coverageWithIntersectingLayers;
        return _ts_generator(this, function(_state) {
            coverageWithIntersectingLayers = _.mapValues(function(product) {
                return filterProductCoverageLayersByIntersection(product, geometry);
            }, coverage);
            return [
                2,
                reorderCoverage(coverageWithIntersectingLayers)
            ];
        });
    });
    return function filterCoverageLayersByIntersection(coverage, geometry) {
        return _ref.apply(this, arguments);
    };
}();
/**
 * Filters out coverage layers that do not overlap with geometry.
 * Does not mutate the underlying geometry.
 * @param coverage
 * @param geometry
 */ export var filterCoverageLayersByOverlap = function(coverage, geometry) {
    return _.mapValues(function(product) {
        return _.set('layers', _.pickBy(function(layer) {
            return hasOverlap(layer.geometry, geometry);
        }, product.layers), product);
    }, coverage);
};
